import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { financialServicesData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function FinancialServicesPage() {
    return <SolutionTemplate {...financialServicesData} />;
}
